;(function (angular) {
   'use strict'

   angular.module('app').controller('recipesEntryController', recipesEntryController)

   function recipesEntryController(
      pageData,
      $rootScope,
      $scope,
      $q,
      commentAndRatingStats,
      CacheFactory,
      util,
      productData,
      viewService,
      priceSettings,
      yamzService
   ) {
      $rootScope.onCmsPageInit(pageData)
      $scope.pageData = pageData
      $scope.formatTotalMinutes = util.formatTotalMinutes
      $scope.commentAndRatingStats = commentAndRatingStats

      var _shopForRecipeCache = CacheFactory.get('shopForRecipeCache') || CacheFactory.createCache('shopForRecipeCache')
      var _shopForRecipeCacheKey = 'shopForRecipe_' + pageData.uuid

      //================================================================================
      // Ingredients
      //================================================================================

      var ingredientGroups = pageData.ingredientGroups.map(function (group) {
         return group.content.items
      })

      var ingredientEntries = [].concat.apply([], ingredientGroups)

      var ingredientEntriesMapped = ingredientEntries
         .map(function (ingredient) {
            return {
               name: ingredient.name,
               searchQueryData: ingredient.searchQueryData,
               ingredientUuid: ingredient.ingredientUuid,
            }
         })
         // If the item's `computed` search query is false, filter it out.
         .filter(function (item) {
            return item.searchQueryData && item.searchQueryData.computed
         })

      var uniqueIngredientIds = util.distinct(
         ingredientEntriesMapped.map(function (item) {
            return item.ingredientUuid
         })
      )

      //================================================================================
      // Scope Functions
      //================================================================================

      $scope.ingredientQuantityMaybeFraction = function (quantity) {
         if (!quantity) {
            return
         }

         if (Number.isInteger(quantity)) {
            return quantity
         }

         var quantityAsString = quantity + ''
         var parts = quantityAsString.split('.')
         var whole = parts[0]
         var decimal = parts[1]

         var prettyFraction

         switch (decimal) {
            case '125':
               prettyFraction = '1&frasl;8'
               break
            case '25':
               prettyFraction = '1&frasl;4'
               break
            case '33':
               prettyFraction = '1&frasl;3'
               break
            case '5':
               prettyFraction = '1&frasl;2'
               break
            case '66':
               prettyFraction = '2&frasl;3'
               break
            case '75':
               prettyFraction = '3&frasl;4'
               break
            case '875':
               prettyFraction = '7&frasl;8'
               break
            case '625':
               prettyFraction = '5&frasl;8'
               break
            case '0625':
               prettyFraction = '1&frasl;16'
               break
         }

         if (parseInt(whole) && prettyFraction) {
            return whole + ' ' + prettyFraction
         }

         return prettyFraction || quantity
      }

      $scope.ingredientUnitSingularOrPlural = function (quantity, unit) {
         if (!quantity || !unit) {
            return
         } else if (quantity > 0 && quantity <= 1) {
            return unit && unit.labelSingular
         } else {
            return unit && unit.labelPlural
         }
      }

      $scope.ingredientsForShopping = uniqueIngredientIds.map(function (ingredientUuid) {
         return ingredientEntriesMapped.find(function (ingredientEntry) {
            return ingredientEntry.ingredientUuid === ingredientUuid
         })
      })

      $scope.ingredientStepHasImage = function (step) {
         return util.isStringTrue(step.has_image) && step.image_src && step.image_src[0]
      }

      $scope.getInstructionStepId = function (groupIndex, stepIndex) {
         return 'step-' + (groupIndex + 1) + '.' + (stepIndex + 1)
      }

      $scope.getJSONLD = function () {
         // https://developers.google.com/search/docs/appearance/structured-data/recipe

         var data = {
            '@context': 'http://schema.org/',
            '@type': 'Recipe',
            name: pageData.title,
            author: {
               '@type': 'Person',
               name: pageData.author && pageData.author.title,
            },
            description: pageData.metaDescription,
            datePublished: pageData.publishedDate || (pageData.hlData && pageData.hlData.published_on),
            image: pageData.primaryImage && [
               $rootScope.createImageSrc(pageData.primaryImage.filename, 'w=1200&ar=1:1&fit=crop'),
               $rootScope.createImageSrc(pageData.primaryImage.filename, 'w=1200&ar=4:3&fit=crop'),
               $rootScope.createImageSrc(pageData.primaryImage.filename, 'w=1200&ar=16:9&fit=crop'),
            ],
         }

         if (commentAndRatingStats) {
            if (commentAndRatingStats.ratingCount) {
               data.aggregateRating = {
                  '@type': 'AggregateRating',
                  ratingValue: commentAndRatingStats.ratingAverage,
                  reviewCount: commentAndRatingStats.ratingCount,
               }
            }
            if (commentAndRatingStats.commentCount) {
               data.interactionStatistic = {
                  '@type': 'InteractionCounter',
                  interactionType: 'http://schema.org/Comment',
                  userInteractionCount: commentAndRatingStats.commentCount,
               }
            }
         }

         if (pageData.ingredientGroups && pageData.ingredientGroups.length) {
            data.recipeIngredient = []
            pageData.ingredientGroups.forEach(function (ingredientGroup) {
               ingredientGroup.content.items.forEach(function (item) {
                  var ingredientStringParts = []

                  if (item.quantity) {
                     ingredientStringParts.push(item.quantity)
                  }
                  if (item.unit) {
                     ingredientStringParts.push($scope.ingredientUnitSingularOrPlural(item.quantity, item.unit))
                  }
                  ingredientStringParts.push(item.name)

                  data.recipeIngredient.push(ingredientStringParts.join(' ').toLowerCase())
               })
            })
         } else if (
            pageData.hlData &&
            pageData.hlData.semiStructuredRecipe &&
            pageData.hlData.semiStructuredRecipe.ingredients
         ) {
            data.recipeIngredient = pageData.hlData.semiStructuredRecipe.ingredients
         }

         if (pageData.instructionGroups && pageData.instructionGroups.length) {
            data.recipeInstructions = []
            pageData.instructionGroups.forEach(function (instructionGroup, groupIndex) {
               instructionGroup.content.items.forEach(function (step, stepIndex) {
                  var stepObject = {
                     '@type': 'HowToStep',
                     text: step.text,
                     url: $rootScope.canonicalUrl + '#' + $scope.getInstructionStepId(groupIndex, stepIndex),
                  }
                  if (step.has_image && step.image_src && step.image_src[0]) {
                     stepObject.image = {
                        '@type': 'ImageObject',
                        url: $rootScope.createImageSrc(pageData.imageMap[step.image_src[0]].filename, 'w=600'),
                        width: 600,
                     }
                  }
                  data.recipeInstructions.push(stepObject)
               })
            })
         } else if (
            pageData.hlData &&
            pageData.hlData.semiStructuredRecipe &&
            pageData.hlData.semiStructuredRecipe.instructions
         ) {
            data.recipeInstructions = pageData.hlData.semiStructuredRecipe.instructions.map(function (item) {
               return {
                  '@type': 'HowToStep',
                  text: item,
               }
            })
         }

         if (pageData.servings || pageData.yield || (pageData.hlData && pageData.hlData.servings)) {
            data.recipeYield = []
            if (pageData.servings) {
               // Note: Following the guideline "For Guided Recipes, the type must be Integer" this is stored as an integer (via https://developers.google.com/search/docs/appearance/structured-data/recipe)
               data.recipeYield.push(parseInt(pageData.servings))
               if (pageData.yield && pageData.yield.amount && pageData.yield.unit) {
                  data.recipeYield.push(pageData.yield.amount + ' ' + pageData.yield.unit)
               }
            } else if (pageData.hlData && pageData.hlData.servings) {
               data.recipeYield.push(pageData.hlData.servings)
            }
         }

         if (pageData.time && pageData.time.prep) {
            data.prepTime = 'PT' + pageData.time.prep + 'M'
         }

         if (pageData.time && pageData.time.cook) {
            data.cookTime = 'PT' + pageData.time.cook + 'M'
         }

         if (pageData.time && pageData.time.total) {
            data.totalTime = 'PT' + pageData.time.total + 'M'
         }

         if (pageData.types && pageData.types.length) {
            // Note: This needs to stay `recipeCategory` in order to match the JSONLD spec
            data.recipeCategory = pageData.types
         }
         if (pageData.cuisines && pageData.cuisines.length) {
            data.recipeCuisine = pageData.cuisines
         }
         if (pageData.tags && pageData.tags.length) {
            data.keywords = pageData.tags.join(', ')
         }

         return JSON.stringify(data)
      }

      $scope.pressedShopForTerm = performShopForRecipeSearch

      //================================================================================

      function performShopForRecipeSearch(termObject) {
         if (!termObject) {
            return
         }

         $scope.activeShopForTermObject = termObject
         $scope.shopForRecipeIsLoading = true

         productData
            .searchProducts(
               undefined,
               termObject.searchQueryData.computed,
               {
                  queryType: 'prefixNone',
                  removeStopWords: ['en'],
                  typoTolerance: false,
                  optionalWords: termObject.searchQueryData.optional,
                  optionalFilters: ['isPromoted:true'],
               },
               true
            )
            .then(function (response) {
               $scope.shopForTermResults = []
               return $q
                  .map(response.hits, function (product) {
                     return viewService
                        .toProductView(product, {
                           priceSettings: priceSettings,
                        })
                        .then(function (productView) {
                           $scope.shopForTermResults.push(productView)
                        })
                  })
                  .then(function () {
                     $scope.shopForRecipeIsLoading = false

                     _shopForRecipeCache.put(_shopForRecipeCacheKey, JSON.stringify(termObject))
                  })
            })
            .catch(function () {
               $scope.shopForTermResults = []
            })
      }

      //================================================================================
      // INIT
      //================================================================================

      function activateFirstShopForRecipeItem() {
         // If there's no cached shop-for-recipe term object, attempt to find and activate the first shoppable item
         // (not all ingredients are shoppable)

         // If there's HL data and the migration is not yet complete, the recipe is not yet shoppable so we can exit early.
         if (pageData.hlData && pageData.hlData.length && !pageData.hlData.migration_complete) {
            return
         }

         var allIngredients = [].concat.apply(
            [],
            pageData.ingredientGroups.map(function (ingredientGroup) {
               return ingredientGroup.content.items
            })
         )

         var firstShoppableIngredient = allIngredients.find(function (ingredient) {
            return ingredient.searchQueryData && ingredient.searchQueryData.primary
         })

         if (firstShoppableIngredient) {
            // Activate the first shoppable item
            performShopForRecipeSearch(firstShoppableIngredient)
         }
      }

      function init() {
         if (!$rootScope.viewportXs) {
            yamzService.init()
         }

         var cachedShopForRecipeTermObject = _shopForRecipeCache && _shopForRecipeCache.get(_shopForRecipeCacheKey)
         if (cachedShopForRecipeTermObject) {
            performShopForRecipeSearch(JSON.parse(cachedShopForRecipeTermObject))
         } else {
            activateFirstShopForRecipeItem()
         }
      }

      init()
   }
})(angular)
